import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_NursingAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_NursingAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <h3>
                    Relevant Medical Conditions</h3>
                <p>
                    <span className='eleHeader'>What was the client's health at birth? Early development?:</span>
                    <span className='small'>(Include any delays with walking, crawling, sitting up, concerns with height/weight, any problems with running, jumping, climbing, balancing, coordination, problems with hearing, vision or speech; current with immunizations)</span>
                    <textarea id="txtBirthHealth" name="txtBirthHealth" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>What is the client's prenatal history?:</span>
                    <span className='small'>(Include any substance abuse, physical abuse, medications, and illnesses during
                        Mother's pregnancy, prenatal exposure to alcohol, tobacco and other drugs)</span>
                    <textarea id="txtPrenatalHx" name="txtPrenatalH" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>Current Health Issues:</span>
                    <textarea id="txtCurrentHealthIssues" name="txtCurrentHealthIssues" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>Past Medical Hospitalizations:</span>
                    <textarea id="txtAccessorsAndCredentials" name="txtAccessorsAndCredentials" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>Significant Injuries:</span>
                    <textarea id="TextBox1" name="TextBox1" className='add-only'></textarea></p>
                <table border={0}>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client's Past Illness:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Anemia" /> Anemia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Asthma" /> Asthma
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Behavioral Problems" /> Behaviora Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Bladder/Kidney Infection" /> Bladder/Kidney Infection
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Chicken Pox" /> Chicken Pox
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Eczema" /> Eczema
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Atopic Dermatitis" /> Atopic Dermatitis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Hypertension" /> Hypertension
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Meningitis" /> Meningitis
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Mononucleosis" /> Mononucleosis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Mumps" /> Mumps
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Pneumonia" /> Pneumonia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Psychological Problems" />  Psychological Problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Scarlet Fever " /> Scarlet Fever
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Seizures" /> Seizures
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Sexually Transmitted Disease" /> Sexually Transmitted Disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Sinus Problems" /> Sinus Problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Ulcers" /> Ulcers
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Whooping Cough" /> Whooping Cough
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" name="chkPastIllnesses" className='add-only' value="Other" /> Other
                        </td>
                    </tr>
                </table>
                <h3>
                    Dental Screening</h3>
                <p>
                    <span className='eleHeader'>Date of Last Dental Visit:</span>
                    <input type='date' id="txtLastDentalVisit" name="txtLastDentalVisit" className='add-only' /></p>
                <table border={0}>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rate Client's Oral Hygiene:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" name="chkOralHygieneRating" className='add-only' value="Excellent" /> Excellent
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="chkOralHygieneRating" className='add-only' value="Good" /> Good
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="chkOralHygieneRating" className='add-only' value="Fair" /> Fair
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="chkOralHygieneRating" className='add-only' value="Poor" /> Poor
                        </td>
                        <td>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>How many times per day does client brush teeth?</span>
                    <input type='text' id="txtAmountBrushTeeth" name="txtAmountBrushTeeth" className='add-only' /></p>
                <p>
                    <span className='eleHeader'>Current Dental Complaints/Needs:</span>
                    <textarea id="txtDentalComplaints" name="txtDentalComplaints" className='add-only'></textarea></p>
                <h3>
                    Nutritional Status</h3>
                <p>
                    <span className='eleHeader'>List Food Allergies/Sensitivities:</span>
                    <textarea id="txtFoodAllergies" name="txtFoodAllergies" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="txtHistoryBinging" className='add-only' value="Client has History of Binge Eating/Induced Vomiting" /> Client has History of Binge Eating/Induced Vomiting
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Number of meals eaten per day:</span>
                            <input type='text' id="txtMealsPerDay" name="txtMealsPerDay" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Number of snacks per day:</span>
                            <input type='text' id="txtSnacksPerDay" name="txtSnacksPerDay" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Number of fast food meals per week:</span>
                            <input type='text' id="txtFastFood" name="txtFastFood" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>List appetite changes:</span>
                    <textarea id="txtAppetiteChanges" name="txtAppetiteChanges" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>List significant weight losses/gains:</span> <span
                        className='small'>Describe pounds and time period.</span>
                    <textarea id="txtWeightChanges" name="txtWeightChanges" className='add-only'></textarea></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input name="cbEatingDisorder" className='add-only' value="Does client have an eating disorder?"
                                type="checkbox" /> Does client have an eating disorder?
                        </td>
                        <td className='w-375'>
                            <input name="cbPrescribedDiet" className='add-only' value="Is client on a medically prescribed diet?"
                                type="checkbox" /> Is client on a medically prescribed diet?
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If on prescribed diet, list details:</span>
                    <textarea id="txtDiet" name="txtDiet" className='add-only'></textarea></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input name="cbWeightLossGainDesire" className='add-only' value="Does client desire to lose or gain weight?"
                                type="checkbox" /> Does client desire to lose or gain weight?
                        </td>
                        <td className='w-375'>
                            Is client's appearance normal or abnormal?
                            <select id="ddlAppearance" name="ddlAppearance" className='add-only'>
                                <option value="*Choose*">*Choose*</option>
                                <option value="Normal">Normal</option>
                                <option value="Abnormal">Abnormal</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <h3>
                    Sexual Behavior</h3>
                <p>
                    <input name="cbIsSexuallyActive" className='add-only' value="Is or has client been sexually active?"
                        type="checkbox" />  Is or has client been sexually active?
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last menstration:</span>
                            <input type='text' id="txtLastMenstration" name="txtLastMenstration" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last pelvic exam:</span>
                            <input type='text' id="txtLastPelvicExam" name="txtLastPelvicExam" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>List date(s) of any miscarriage(s):</span>
                            <textarea id="txtMiscarriage" name="txtMiscarriage" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>List date(s) of any abortion(s):</span>
                            <textarea id="txtAbortion" name="txtAbortion" className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <input name="cbIsLactating" value="Is client lactating?" type="checkbox" className='add-only' /> Is client lactating?
                        </td>
                    </tr>
                </table>
                <table border={0}>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="Problems with Pregnancy" /> Problems with Pregnancy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="Penile Discharge" />  Penile Discharge
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="Pelvic Pain" /> Pelvic Pain
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="UTI" /> UTI
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="Gynecomastia" />  Gynecomastia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="Dysuria" /> Dysuria
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="Nipple Discharge" /> Nipple Discharge
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSexualProblems" className='add-only' value="Prostate Problems" /> Prostate Problems
                        </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                </table>
                <h3>
                    Mood Changes</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbRecentMoodChanges" className='add-only' value="Has client had recent mood changes?" /> Has client had recent mood changes?
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbSadEvent" className='add-only' value="Has client experienced a recent sad event concerting family/friends?" />  Has client experienced a recent sad event concerting family/friends?
                        </td>
                    </tr>
                </table>
                <h3>
                    Sleep Patterns</h3>
                <p>
                    <span className='eleHeader'>List any sleep problems the client has experienced:</span>
                    <textarea id="txtSleepProblems" name="txtSleepProblems" className='add-only'></textarea></p>
                <h3>
                    Allergies</h3>
                <p>
                    <span className='eleHeader'>List drug allergies:</span>
                    <textarea id="txtDrugAllergies" name="txtDrugAllergies" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>List environmental allergies:</span>
                    <textarea id="txtEnvironmentalAllergies" name="txtEnvironmentalAllergies" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>List contact allergies:</span>
                    <textarea id="txtContactAllergies" name="txtContactAllergies" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbEpiPen" className='add-only' value="Client uses an epi pen." /> Client uses an epi pen.</p>
                <h3>
                    Functional Screening</h3>
                <p>
                    <input type="checkbox" name="cbPerformADL" className='add-only' value="Client is physically able to preform age-appropriate ADL's independently." /> Client is physically able to preform age-appropriate ADL's independently.</p>
                <p>
                    <span className='eleHeader'>If not, describe:</span>
                    <textarea id="txtPerformADLDescription" name="txtPerformADLDescription" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbPhysHealthNegAffect" className='add-only' value="Client's physical health negatively affect other activities." /> Client's physical health negatively affect other activities.</p>
                <p>
                    <span className='eleHeader'>If so, describe:</span>
                    <textarea id="txtPhysHealthDescription" name="txtPhysHealthDescription" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbSpecialNeeds" className='add-only' value="Client has special needs or requires any special equipment." /> Client has special needs or requires any special equipment.<br />
                    <input type="checkbox" name="cbDifficultySwallowing" className='add-only' value="Client has difficulty swallowing." /> Client has difficulty swallowing.<br />
                    <input type="checkbox" name="cbOBComplications" className='add-only' value="Client had pregnancy, labor or delivery complications." /> Client had pregnancy, labor or delivery complications.<br />
                    <input type="checkbox" name="txtClearSpeech" className='add-only' value="Client's speech is understandable." /> Client's speech is understandable.</p>
                <h3>
                    Hygiene</h3>
                <p>
                    <span className='eleHeader'>Describe client's hygiene:</span>
                    <textarea id="txtDescribeHygiene" name="txtDescribeHygiene" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbEncopresisProblems" className='add-only' value="Client has problems with encopresis or enuresis." /> Client has problems with encopresis or enuresis.</p>
                <p>
                    <span className='eleHeader'>If so, how often?</span>
                    <textarea id="txtEncopresisHowOften" name="txtEncopresisHowOften" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>Describe client's appearance:</span>
                    <textarea id="txtClientAppearance" name="txtClientAppearance" className='add-only'></textarea></p>
                <h3>
                    Pain Screening</h3>
                <p>
                    <input type="checkbox" name="cbCurrentPain" className='add-only' value="Client is currently complaining of pain." /> Client is currently complaining of pain.</p>
                <table border={0}>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If so, give pain rating:</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" name="chkPainRating" className='add-only' value="None" /> None
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="1" /> 1
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="2" /> 2
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="3" /> 3
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="4" /> 4
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="5" /> 5
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="6" /> 6
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="7" /> 7
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="8" /> 8
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="9" /> 9
                            &nbsp;
                            <input type="checkbox" name="chkPainRating" className='add-only' value="10" /> 10
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If client has pain that interferes with daily lifestyle,
                        please describe:</span>
                    <textarea id="txtPainInterferes" name="txtPainInterferes" className='add-only'></textarea></p>
                <h3>
                    Vitals</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Height:</span>
                            <input type='text' id="txtHeight" name="txtHeight" className='add-only' />
                            (inches)
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Weight:</span>
                            <input type='text' id="txtWeight" name="txtWeight" className='add-only' />
                            (pounds)
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>BMI:</span>
                            <input type='text' id="txtBMI" name="txtBMI" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Birth Weight:</span>
                            <input type='text' id="txtBirthWeight" name="txtBirthWeight" className='add-only' /><br />
                            <input type="checkbox" name="cbPrematurelyBorn" className='add-only' value="Prematurely born?" /> Prematurely born?
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Temperature:</span>
                            <input type='text' id="txtTemperature" name="txtTemperature" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Method used:</span>
                            <input type='text' id="txtMethodUsed" name="txtMethodUsed" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Pulse/min.:</span>
                            <input type='text' id="txtPulse" name="txtPulse" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Respirations/min.:</span>
                            <input type='text' id="txtRespirations" name="txtRespirations" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Blood pressure (sitting):</span>
                            <input type='text' id="txtBP" name="txtBP" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    Vision Screening</h3>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Without Correction:</span>
                            <input type='text' id="txtVisionWithoutCorrection" name="txtVisionWithoutCorrection" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Right Eye:</span>
                            <input type='text' id="txtRightEye" name="txtRightEye" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Left Eye:</span>
                            <input type='text' id="txtLeftEye" name="txtLeftEye" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Both Eyes:</span>
                            <input type='text' id="txtBothEyes" name="txtBothEyes" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>With Correction:</span>
                            <input type='text' id="txtVisionWithCorrection" name="txtVisionWithCorrection" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Right Eye:</span>
                            <input type='text' id="txtRightEyeWith" name="txtRightEyeWith" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Left Eye:</span>
                            <input type='text' id="txtLeftEyeWith" name="txtLeftEyeWith" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Both Eyes:</span>
                            <input type='text' id="txtBothEyesWith" name="txtBothEyesWith" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" name="cbWearsGlasses" className='add-only' value="Client wears glasses." /> Client wears glasses
                    <br />
                    <input type="checkbox" name="cbWearsContacts" className='add-only' value="Client wears contacts." /> Client wears contacts.</p>
                <div>
                    <table>
                        <tr>
                            <td className='w-375'>
                                <span className='eleHeader'>If so, what kind:</span>
                                <input type='text' id="txtContactsKind" name="txtContactsKind" className='add-only' />
                            </td>
                            <td className='w-375'>
                                <span className='eleHeader'>Time wearing glasses/contacts:</span>
                                <input type='text' id="txtTimeWearing" name="txtTimeWearing" className='add-only' />
                            </td>
                        </tr>
                    </table>
                </div>
                <h3>
                    Pediulosis Screening</h3>
                <p>
                    <span className='eleHeader'>Pediculosis Screening Result:</span>
                    <textarea id="txtPediculosisResult" name="txtPediculosisResult" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>If positive, describe treatment to be initiated or requested
                        to be done:</span>
                    <textarea id="txtPediculosisTreatment" name="txtPediculosisTreatment" className='add-only'></textarea></p>
                <h3>
                    Medications</h3>
                <p>
                    <span className='eleHeader'>List Current Medications:</span> <span className='small'>
                        Include: 1) Name of medicine, 2) Prescribing doctor, 3) Dosage, 4) Prescription
                        date.</span>
                    <textarea id="txtMedications" name="txtMedications" className='add-only'></textarea></p>
                <h3>
                    Medication Self-Administration Competency Assessment</h3>
                <p>
                    <input type="checkbox" name="cbStateMedNames" className='add-only' value="Client is able to state the name(s) of their medication(s)." /> Client is able to state the name(s) of their medication(s).<br />
                    <input type="checkbox" name="cbStateMedDoses" className='add-only' value="Client is able to state the dose(s) of their medication(s)." /> Client is able to state the dose(s) of their medication(s).<br />
                    <input type="checkbox" name="cbRecognizeMeds" className='add-only' value="Client recognizes their medication(s) upon visual inspection." /> Client recognizes their medication(s) upon visual inspection.<br />
                    <input type="checkbox" name="cbMedEffectsExplained" className='add-only' value="The medication(s) side effects and risks have been explained to client." /> The medication(s) side effects and risks have been explained to client.<br />
                    <input type="checkbox" name="cbSelfAdminDeficits" className='add-only' value="Does client have any deficits that limit their ability to self-administer medication(s) under supervision." /> Does client have any deficits that limit their ability to self-administer medication(s)
                    under supervision.<br />
                    <input type="checkbox" name="txtSelfAdminCompetent" className='add-only' value="Client is competent to self-administer medication with supervision." /> Client is competent to self-administer medication with supervision.<br />
                </p>
                <h3>
                    Family Health History</h3>
                <p>
                    <input type="checkbox" name="cbArthritis" className='add-only' value="Arthritis" /> Arthritis
                </p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtArthritis" name="txtArthritis" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbAsthma" className='add-only' value="Asthma" /> Asthma</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtAsthma" name="txtAsthma" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbCancer" className='add-only' value="Cancer" /> Cancer</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtCancer" name="txtCancer" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbColitis" className='add-only' value="Colitis" /> Colitis</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtColitis" name="txtColitis" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbDiabetes" className='add-only' value="Diabetes" /> Diabetes</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtDiabetes" name="txtDiabetes" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbEczema" className='add-only' value="Eczema" /> Eczema</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtEczema" name="txtEczema" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbGallBladder" className='add-only' value="Gall Bladder Disease" /> Gall Bladder Disease
                </p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtGallBladder" name="txtGallBladder" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbSinus" className='add-only' value="Hay Fever or Sinus" /> Hay Fever or Sinus</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtSinus" name="txtSinus" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbHeartDisease" className='add-only' value="Heart Disease" /> Heart Disease</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtHeartDisease" name="txtHeartDisease" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbHypertension" className='add-only' value="Hypertension" />  Hypertension</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtHypertension" name="txtHypertension" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbKidneyDisease" className='add-only' value="Kidney Disease" /> Kidney Disease</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtKidneyDisease" name="txtKidneyDisease" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbRetardation" className='add-only' value="Mental Retardation" /> Mental Retardation
                </p>

                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtRetardation" name="txtRetardation" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbEmo" className='add-only' value="Psychiatric/Emotional Problems" /> Psychiatric/Emotional Problems</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtEmo" name="txtEmo" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbAnemia" className='add-only' value="Sickle Cell Anemia" /> Sickle Cell Anemia</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtAnemia" name="txtAnemia" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbStroke" className='add-only' value="Stroke" /> Stroke</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtStroke" name="txtStroke" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbSubAbuse" className='add-only' value="Substance Addiction" /> Substance Addiction</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtSubAbuse" name="txtSubAbuse" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbThyroidDisease" className='add-only' value="Thyroid Disease" /> Thyroid Disease</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtThyroidDisease" name="txtThyroidDisease" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbTuberculosis" className='add-only' value="Tuberculosis" /> Tuberculosis</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtTuberculosis" name="txtTuberculosis" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" name="cbUlcers" className='add-only' value="Ulcers" /> Ulcers</p>
                <p>
                    <span className='eleHeader'>Family member affected and additional information:</span>
                    <textarea id="txtUlcers" name="txtUlcers" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>Additional information regarding client's family health
                        history:</span><br />
                    <textarea id="txtAdditionalFamilyHealthHistory" name="txtAdditionalFamilyHealthHistory"
                        className='add-only'></textarea></p>
                <h3>
                    Summary and Recommendations</h3>
                <p>
                    <span className='eleHeader'>Enter summary and recommendations:</span>
                    <textarea id="txtSummary" name="txtSummary" className='add-only'></textarea>
                </p>


            </div>
        </form >
    )
}